import { Config } from "tailwindcss/types/config";
import typography from "@tailwindcss/typography";

export default {
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}"],
  theme: {
    extend: {
      colors: {
        // Brand
        primary: {
          DEFAULT: "#516C70",
          soft: "#9BABAD",
          strong: "#062D33",
        },
        secondary: {
          DEFAULT: "#A0F069",
          soft: "#C6F6A5",
          strong: "#89CE59",
        },
        tertiary: {
          DEFAULT: "#AACDFF",
          soft: "#CEE2FF",
          strong: "#85B7FF",
        },
        fourth: {
          DEFAULT: "#E5F0E9",
          soft: "#F9FBFA",
          strong: "#DFECE4",
        },
        negative: {
          DEFAULT: "#a5506e",
          strong: "#944863",
          soft: "#bb5a7c",
        },
        // Neutral scale
        neutral: {
          50: "#FFFFFF",
          100: "#F5F5F5",
          200: "#E3E3E3",
          300: "#C6C6C6",
          400: "#868686",
          500: "#707070",
          600: "#5E5E5E",
          700: "#393939",
          800: "#303030",
          900: "#282828",
        },
        // Text
        text: {
          DEFAULT: "#5E5E5E",
          soft: "#868686",
          strong: "#282828",
          "on-strong": "#FFFFFF",
          disabled: "#868686",
        },
        // Surface
        surface: {
          DEFAULT: "#FFFFFF",
          soft: "#F9FAFC",
          "soft-2": "#F3F8FF",
          medium: "#F5F9F7",
          strong: "#062D33",
          disabled: "#F5F5F5",
        },
        // Border
        border: {
          DEFAULT: "#C6C6C6",
          soft: "#E3E3E3",
          strong: "#282828",
          disabled: "#C6C6C6",
        },
        // Status
        info: {
          soft: "#B0E3FF",
          strong: "#60C6FF",
        },
        error: {
          soft: "#F6D1D1",
          strong: "#E26666",
        },
        warning: {
          soft: "#FFFAE2",
          strong: "#FFE418",
        },
        success: {
          soft: "#B2E8E1",
          strong: "#008575",
        },
        // Additional colors
        overlay: "rgba(40, 40, 40, 0.54)",
        grey: {
          DEFAULT: "#C8CDD2",
          dark: "#82878C",
          light: "#DCE1E6",
          "x-light": "#e9edf2",
        },
        background: {
          DEFAULT: "#F2F8FE",
          disabled: "#E9ECEF",
        },
        content: {
          DEFAULT: "#142341",
          disabled: "#82878C",
        },
        cnam: {
          DEFAULT: "#2F384D",
          blue: {
            DEFAULT: "#1C4094",
            light: "#E2EBFF",
          },
          light: {
            100: "#EFF2F7",
            200: "#D0D9E9",
            300: "#9CA8C8",
          },
          bright: "#3079F2",
          pink: "#ED76B3",
        },
        "grey-blue": {
          300: "#9CA8C8",
          500: "#495471",
        },
        "light-blue": {
          100: "#E2EBFF",
          200: "#D0D9E9",
        },
        "blue-medium": {
          DEFAULT: "#0C419A",
        },
        "blue-strong": {
          DEFAULT: "#07275C",
        },
        kpi: {
          green: {
            soft: "#DAFDEBCC",
            strong: "#218C26",
          },
          blue: {
            soft: "#CCE7FFCC",
            strong: "#4646BB",
          },
          red: {
            soft: "#FFE0EACC",
            strong: "#B04D56",
          },
          purple: {
            soft: "#F3E7FF",
            strong: "#7D4BBC",
          },
          turquoise: {
            soft: "#C5F2ECCC",
            strong: "#1A6758",
          },
          orange: {
            soft: "#FFE7CFCC",
            strong: "#CF7822",
          },
          grey: {
            soft: "#E8ECEFCC",
            strong: "#536471",
          },
        },
      },
      fontFamily: {
        sans: ["Roboto", "system-ui", "sans-serif"],
        roboto: ["Roboto", "system-ui", "sans-serif"],
        manrope: ["Manrope", "system-ui", "sans-serif"],
        jakarta: ["Jakarta", "system-ui", "sans-serif"],
      },
      textColor: {
        DEFAULT: "#5E5E5E",
      },
      screens: {
        xs: "480px",
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px",
      },
    },
  },
  plugins: [typography],
} satisfies Config;
